export default __webpack_public_path__ + "static/media/study2c.0efc1d52.png";